var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// @ts-nocheck
import { QueryBatcher } from './batcher';
import { GenqlError } from './error';
var DEFAULT_BATCH_OPTIONS = {
    maxBatchSize: 10,
    batchInterval: 40,
};
export var createFetcher = function (_a) {
    var url = _a.url, _b = _a.headers, headers = _b === void 0 ? {} : _b, fetcher = _a.fetcher, _fetch = _a.fetch, _c = _a.batch, batch = _c === void 0 ? false : _c, rest = __rest(_a, ["url", "headers", "fetcher", "fetch", "batch"]);
    if (!url && !fetcher) {
        throw new Error('url or fetcher is required');
    }
    fetcher = fetcher || (function (body) { return __awaiter(void 0, void 0, void 0, function () {
        var headersObject, _a, fetchImpl, res, _b, _c, _d, json;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!(typeof headers == 'function')) return [3 /*break*/, 2];
                    return [4 /*yield*/, headers()];
                case 1:
                    _a = _e.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = headers;
                    _e.label = 3;
                case 3:
                    headersObject = _a;
                    headersObject = headersObject || {};
                    if (typeof fetch === 'undefined' && !_fetch) {
                        throw new Error('Global `fetch` function is not available, pass a fetch polyfill to Genql `createClient`');
                    }
                    fetchImpl = _fetch || fetch;
                    return [4 /*yield*/, fetchImpl(url, __assign({ headers: __assign({ 'Content-Type': 'application/json' }, headersObject), method: 'POST', body: JSON.stringify(body) }, rest))];
                case 4:
                    res = _e.sent();
                    if (!!res.ok) return [3 /*break*/, 6];
                    _b = Error.bind;
                    _d = (_c = "".concat(res.statusText, ": ")).concat;
                    return [4 /*yield*/, res.text()];
                case 5: throw new (_b.apply(Error, [void 0, _d.apply(_c, [_e.sent()])]))();
                case 6: return [4 /*yield*/, res.json()];
                case 7:
                    json = _e.sent();
                    return [2 /*return*/, json];
            }
        });
    }); });
    if (!batch) {
        return function (body) { return __awaiter(void 0, void 0, void 0, function () {
            var json;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetcher(body)];
                    case 1:
                        json = _b.sent();
                        if (Array.isArray(json)) {
                            return [2 /*return*/, json.map(function (json) {
                                    var _a;
                                    if ((_a = json === null || json === void 0 ? void 0 : json.errors) === null || _a === void 0 ? void 0 : _a.length) {
                                        throw new GenqlError(json.errors || [], json.data);
                                    }
                                    return json.data;
                                })];
                        }
                        else {
                            if ((_a = json === null || json === void 0 ? void 0 : json.errors) === null || _a === void 0 ? void 0 : _a.length) {
                                throw new GenqlError(json.errors || [], json.data);
                            }
                            return [2 /*return*/, json.data];
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    }
    var batcher = new QueryBatcher(function (batchedQuery) { return __awaiter(void 0, void 0, void 0, function () {
        var json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetcher(batchedQuery)];
                case 1:
                    json = _a.sent();
                    return [2 /*return*/, json];
            }
        });
    }); }, batch === true ? DEFAULT_BATCH_OPTIONS : batch);
    return function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var json;
        var query = _b.query, variables = _b.variables;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, batcher.fetch(query, variables)];
                case 1:
                    json = _c.sent();
                    if (json === null || json === void 0 ? void 0 : json.data) {
                        return [2 /*return*/, json.data];
                    }
                    throw new Error('Genql batch fetcher returned unexpected result ' + JSON.stringify(json));
            }
        });
    }); };
};
